import React from 'react';
import { CTAButton } from './CTAButton';
export const HeroSection: React.FC = () => {
  return <section className="bg-gradient-to-br from-green-dark via-green-mid to-brown-dark text-white text-center pt-[50px] px-5 pb-[30px] relative overflow-hidden" data-id="element-122" data-mp="2hvce8k4abd5h">
      <div className="text-[11px] font-sans font-bold tracking-[3px] text-[#A5D6A7] uppercase mb-1.5" data-id="element-123" data-mp="23x4hac790bub">
        🌿 TIERRA VIVA™
      </div>
      <h1 className="text-[clamp(24px,4.5vw,46px)] leading-[1.08] font-black mb-2 max-w-[750px] mx-auto" data-id="element-124" data-mp="2wj78w61urrl7">
        Todo lo que necesitás para
        <br data-id="element-125" data-mp="30kixq9cwk8sc" />
        construir tu casa de barro.
        <br data-id="element-126" data-mp="2mufi418j3dbv" />
        <em className="text-gold-main not-italic" data-id="element-127" data-mp="2mup6xlhu7efz">Listo. Desde hoy.</em>
      </h1>

      <div className="flex justify-center mb-3 w-full max-w-sm mx-auto" data-id="element-128" data-mp="2rsh00iu7x6lr">
        <img src="https://cdn.magicpatterns.com/uploads/eVh5m7RKDUPcvcCpXhfET2/eb3fb1ef-73ad-4646-86eb-9620a5d20949.png" alt="Mega Pack Tierra Viva" className="w-full max-w-[260px] h-auto object-contain drop-shadow-2xl" data-id="element-129" data-mp="2rqntd3jlumdr" />
      </div>

      <p className="text-[clamp(14px,2.2vw,19px)] font-sans font-bold text-[#C8E6C9] mb-1" data-id="element-130" data-mp="2ffs2pjeipiws">
        MEGA PACK TIERRA VIVA — Trilogía Completa + 4 Bonos Pro
      </p>
      <p className="text-[clamp(13px,1.8vw,16px)] text-[#A5D6A7] max-w-[600px] mx-auto mb-4 font-sans leading-[1.5]" data-id="element-131" data-mp="2p5lbydr6tlxv">
        El sistema N°1 de bioconstrucción para el autoconstructor moderno — Del
        suelo al techo — Sin experiencia previa necesaria
      </p>

      <div className="flex justify-center flex-wrap gap-1.5 mb-4 max-w-[500px] mx-auto" data-id="element-132" data-mp="2u4erscty5p17">
        {['📄 100% PDF', '⚡ 5 min', '🏗️ 3 Tomos', '📐 150 Págs', '🌿 2026'].map((pill, i) => <span key={i} className="bg-white/10 border border-white/20 text-white py-1 px-2.5 rounded-full text-[10px] font-sans font-semibold" data-id="element-133" data-mp="336e9768viv4o" data-mpi={i}>
            {pill}
          </span>)}
      </div>

      <CTAButton href="#oferta-master" data-id="element-134" data-mp="18tg20vih0elk">
        🌿 → QUIERO MI MEGA PACK AHORA
      </CTAButton>

      <p className="text-[12px] text-[#A5D6A7] mt-2 font-sans" data-id="element-135" data-mp="38vnzaokebhaj">
        🛡️ Garantía 7 días &nbsp;|&nbsp; 🔒 Pago seguro &nbsp;|&nbsp; 💳 Mercado
        Pago
      </p>

      <div className="flex justify-center flex-wrap gap-[25px] mt-[30px] pt-[25px] border-t border-white/10" data-id="element-136" data-mp="3ipxt8aozknnd">
        <div className="text-center" data-id="element-137" data-mp="3mufd09vcj0y5">
          <span className="block text-[26px] font-black text-gold-main leading-none" data-id="element-138" data-mp="3rsgrehhtuc3a">
            +300
          </span>
          <span className="text-[10px] text-[#A5D6A7] font-sans uppercase tracking-[1px] mt-1 block" data-id="element-139" data-mp="l49u1d17wmu">
            autoconstructores
          </span>
        </div>
        <div className="text-center" data-id="element-140" data-mp="5eytx5wjudmg">
          <span className="block text-[26px] font-black text-gold-main leading-none" data-id="element-141" data-mp="abz15k54xmf5">
            3
          </span>
          <span className="text-[10px] text-[#A5D6A7] font-sans uppercase tracking-[1px] mt-1 block" data-id="element-142" data-mp="eelrfgm5qza8">
            tomos completos
          </span>
        </div>
        <div className="text-center" data-id="element-143" data-mp="23u67f9xdg39s">
          <span className="block text-[26px] font-black text-gold-main leading-none" data-id="element-144" data-mp="23v7phyct1q10">
            4
          </span>
          <span className="text-[10px] text-[#A5D6A7] font-sans uppercase tracking-[1px] mt-1 block" data-id="element-145" data-mp="1yu0ezrja2cqn">
            bonos incluidos
          </span>
        </div>
        <div className="text-center" data-id="element-146" data-mp="1pvf1iasnxnwq">
          <span className="block text-[26px] font-black text-gold-main leading-none" data-id="element-147" data-mp="1pwho46iyd46u">
            4.9/5
          </span>
          <span className="text-[10px] text-[#A5D6A7] font-sans uppercase tracking-[1px] mt-1 block" data-id="element-148" data-mp="2mmqrq2z0901z">
            calificación ⭐
          </span>
        </div>
      </div>
    </section>;
};